import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { AuthLayout } from '@/components/layout/auth-layout';
import { useAuthStore } from '@/lib/auth-store';

/**
 * Pagina exibida quando um user autenticado nao tem nenhum tenant ativo.
 *
 * Cenarios em que isso pode ocorrer:
 *  - Usuario foi removido de todos os tenants (membership soft-deleted).
 *  - Convite/primeiro acesso ainda nao processado corretamente.
 *  - Estado de borda apos manutencao administrativa.
 *
 * Criar tenant e privilegio EXCLUSIVO de super_admin via painel
 * /admin/clientes/novo. Membros nao tem essa acao disponivel.
 */
export default function SemEscritorioPage() {
  const signOut = useAuthStore((s) => s.signOut);

  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>Sem escritório ativo</CardTitle>
          <CardDescription>
            Sua conta não está vinculada a nenhum escritório no momento.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-[var(--fg-muted)]">
          <p>
            O acesso a um escritório é feito mediante convite enviado por um
            administrador. Se você esperava ter acesso a algum escritório,
            entre em contato com o responsável para reenviar o convite ou
            verificar sua permissão.
          </p>
          <p>
            Em caso de dúvida, fale com o suporte.
          </p>
        </CardContent>
        <CardFooter>
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={() => void signOut('manual')}
          >
            Sair
          </Button>
        </CardFooter>
      </Card>
    </AuthLayout>
  );
}
